import React, { Suspense, lazy } from "react";
import HeaderSkeleton from "ui/Skeletons/HeaderSkeleton";
// import useOnlineStatus from "@/hooks/useDetectOnline";

const Header = lazy(() => import("layout/Header/Header"));
// const Footer = lazy(() => import("../Footer/Footer"));

const Wrapper = (props) => {
  const { children,
     isHeader, // if Header is needed, send true, otherwise send false
     isFooter, // if Foooter is needed, send true, otherwise send false
     headerTitle
    } = props;

  //   useOnlineStatus()
  return (
    <>
      {isHeader && (
        <Suspense fallback={<HeaderSkeleton />}>
          <Header title={headerTitle}/>
        </Suspense>
      )}
      {children}
      {isFooter && (
        <Suspense fallback={<HeaderSkeleton />}>{/* <Footer /> */}</Suspense>
      )}
    </>
  );
};

export default Wrapper;
